import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

// Your Supabase Edge Function URL
const DASHBOARD_API_URL = "https://fztfytovnyxxetzgjzxl.supabase.co/functions/v1/authentication/auth-dashboard";

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('auth_token');

      // If no token, immediately mark as not authenticated
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      try {
        // Call the Supabase Edge Function to check JWT validity
        const res = await axios.get(DASHBOARD_API_URL, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (res.status === 200) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        // If token is invalid or expired, clear stored auth
        if (error.response && [401, 403].includes(error.response.status)) {
          localStorage.removeItem('auth_token');
          localStorage.removeItem('user_email');
        }
        setIsAuthenticated(false);
      }
    };

    verifyToken();

    // Optional: Re-check JWT validity every 60 seconds
    const interval = setInterval(verifyToken, 60000);
    return () => clearInterval(interval);

  }, []);

  // Loading state until we know if user is authenticated
  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  // Redirect to /login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Render protected children if authenticated
  return children;
};

export default ProtectedRoute;
